import { normalizeUserCode } from './validation.js';

const KEY = 'amumin.pending-pairing';
const TTL = 10 * 60_000;
let pending: { code: string; savedAt: number } | null = null;

/** Preserve only a validated pairing code, never an arbitrary redirect URL. */
export function rememberPairingLocation(): void {
  if (typeof window === 'undefined' || window.location.pathname !== '/pair') return;
  const raw =
    new URLSearchParams(window.location.hash.slice(1)).get('code') ??
    new URLSearchParams(window.location.search).get('code') ??
    '';
  const code = normalizeUserCode(raw);
  if (!code) return;
  pending = { code, savedAt: Date.now() };
  try {
    sessionStorage.setItem(KEY, JSON.stringify(pending));
  } catch {
    /* Memory fallback. */
  }
}

/** Non-consuming: both login completion and its authenticated effect may call this. */
export function loginDestination(): string {
  try {
    const stored = sessionStorage.getItem(KEY);
    if (stored) pending = JSON.parse(stored);
  } catch {
    /* Memory fallback. */
  }
  if (
    pending &&
    typeof pending.code === 'string' &&
    normalizeUserCode(pending.code) &&
    Number.isFinite(pending.savedAt) &&
    Date.now() >= pending.savedAt &&
    Date.now() - pending.savedAt < TTL
  ) {
    return '/pair#code=' + encodeURIComponent(normalizeUserCode(pending.code)!);
  }
  clearPairingResume();
  return '/vandaag';
}

export function clearPairingResume(): void {
  pending = null;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Storage unavailable. */
  }
}
